import React, { useEffect, useState } from 'react'
import { SiGooglecloud, SiGithub } from 'react-icons/si'
import { MdVerified } from 'react-icons/md'
import { FaExternalLinkAlt, FaSearchPlus, FaTimes } from 'react-icons/fa'
import Reveal from './Reveal'
import Tilt from 'react-parallax-tilt'
import googleBadge from '../Assets/Google Cloud Engineer Certification Badge.png'
import githubBadge from '../Assets/github-badge.png'
import claudeCert from '../Assets/certificate-xyxw2njd7348-1778577668_page-0001.jpg'

// To show a certificate image or badge, save it in src/Assets/, import it here and set `image`. To make a badge link out, set `url` to its credential page.
const certs = [
  {
    title: 'Claude Certified Architect',
    level: 'Foundation',
    issuer: 'Anthropic',
    icon: <MdVerified />,
    color: '#d97757',
    image: claudeCert,
    url: 'https://verify.skilljar.com/c/xyxw2njd7348',
    valid: 'Valid May 9 – Nov 9, 2026',
  },
  {
    title: 'Associate Cloud Engineer',
    level: 'Associate',
    issuer: 'Google Cloud',
    icon: <SiGooglecloud />,
    color: '#4285f4',
    image: googleBadge,
    fit: 'contain',
    url: 'https://www.credly.com/badges/0633955a-fcfc-4f36-95c8-7f06229a9eba/linked_in_profile',
  },
  {
    title: 'GitHub Foundations',
    level: 'Foundations',
    issuer: 'GitHub',
    icon: <SiGithub />,
    color: '#24292f',
    image: githubBadge,
    fit: 'contain',
    url: 'https://www.credly.com/badges/658a8297-0489-45a8-b035-e4264463a64b/linked_in_profile',
  },
]

function Certifications() {
  const [zoom, setZoom] = useState(null)

  useEffect(() => {
    if (!zoom) return
    const onKey = e => e.key === 'Escape' && setZoom(null)
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [zoom])

  return (
    <div className="section">
      <div className="section-inner">
        <Reveal>
          <div className="section-tag">credentials</div>
          <h2 className="section-title">Certified <span>& verified</span></h2>
        </Reveal>
        <div className="cert-grid">
          {certs.map((c, i) => {
            return (
              <Reveal key={c.title} delay={i * 120} className="cert-cell">
                <Tilt tiltMaxAngleX={10} tiltMaxAngleY={10} glareEnable glareMaxOpacity={0.15} glareBorderRadius="20px" scale={1.03} style={{ height: '100%' }}>
                  <div className="cert-card" style={{ '--cert': c.color }}>
                    {c.image ? (
                      <button type="button" className={`cert-preview ${c.fit === 'contain' ? 'contain' : ''}`} onClick={() => setZoom(c)} aria-label={`Zoom ${c.title} certificate`}>
                        <img src={c.image} alt={`${c.title} certificate`} loading="lazy" />
                        <span className="cert-zoom"><FaSearchPlus /></span>
                      </button>
                    ) : (
                      <div className="cert-badge">{c.icon}</div>
                    )}
                    <div className="cert-level">{c.level}</div>
                    <h3 className="cert-title">{c.title}</h3>
                    <div className="cert-issuer"><MdVerified /> {c.issuer}</div>
                    {c.valid && <div className="cert-valid">{c.valid}</div>}
                    {c.url && (
                      <a className="cert-link" href={c.url} target="_blank" rel="noreferrer">
                        View credential <FaExternalLinkAlt />
                      </a>
                    )}
                  </div>
                </Tilt>
              </Reveal>
            )
          })}
        </div>
      </div>

      {zoom && (
        <div className="media-modal" onClick={() => setZoom(null)} role="dialog" aria-modal="true" aria-label={`${zoom.title} certificate`}>
          <div className={`media-modal-box ${zoom.fit === 'contain' ? 'transparent' : ''}`} onClick={e => e.stopPropagation()}>
            <button className="media-modal-close" onClick={() => setZoom(null)} aria-label="Close">
              <FaTimes />
            </button>
            <img src={zoom.image} alt={`${zoom.title} certificate`} />
          </div>
        </div>
      )}
    </div>
  )
}

export default Certifications
